import React from "react";
import { LOGO_URL } from "../lib/brand";

/**
 * Internal dashboard brand logo.
 * The user's logo asset (ecomcatalog.ai) has a white canvas — we render it
 * inside a rounded white tile so it looks intentional on the dark theme.
 *
 * The wordmark uses bright gradients on every part so it stays legible on
 * BOTH dark and light surfaces — no `variant` switch needed.
 */
export function BrandLogo({ size = 40, showWordmark = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <span
        className="shrink-0 grid place-items-center rounded-xl bg-white shadow-[0_4px_18px_-4px_rgba(79,70,229,0.55),inset_0_0_0_1px_rgba(255,255,255,0.5)]"
        style={{ width: size, height: size }}
      >
        <img
          src={LOGO_URL}
          alt="EcomCatalog AI"
          className="object-contain select-none"
          style={{ width: size * 0.86, height: size * 0.86 }}
          draggable={false}
        />
      </span>
      {showWordmark && (
        <div className="font-display font-semibold tracking-tight text-lg leading-none">
          <span
            style={{
              background: "linear-gradient(135deg, #6366F1 0%, #818CF8 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            ecom
          </span>
          <span
            style={{
              background: "linear-gradient(135deg, #FF3F6C 0%, #FF905A 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            catalog
          </span>
          <span
            className="text-[0.62em] font-bold tracking-[0.18em] uppercase ml-1.5 px-1.5 py-0.5 rounded"
            style={{
              background: "linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)",
              color: "#FFFFFF",
              boxShadow: "0 4px 14px -4px rgba(124,58,237,0.6)",
            }}
          >
            .AI
          </span>
        </div>
      )}
    </div>
  );
}

export default BrandLogo;
